import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody } from "../../../../shared/components/Card";
import {
  LinkAnchor,
  LinkSpan,
} from "../../../../shared/components/form/FormElements";
import { BoldSpan, NormalSpan } from "../..";
import { useAuth } from "../../../../contexts/AuthContext";
import format from "date-fns/format";
import PaymentMethod from "../../components/PaymentMethod";
import { formatNumber } from "../../../../shared/helpers";

const CurrentPlanCard = ({
  planImg,
  planType,
  currency,
  totalAmount,
  duration,
  qtyPriceString,
  renewsOn,
  onChangePlanClick,
  onReactivateClick,
  //handleChangeCancel,
  setShowComparePlans,
  isAndroid,
  isIos,
  stripeStatus,
  paymentData,
}) => {
  const { t } = useTranslation("common");
  const { isPaymentOverdue } = useAuth();

  return (
    <Card shadow="true">
      <CardBody
        className="d-flex justify-content-between"
        style={{ padding: "1.2rem 2.4rem" }}
      >
        <div className="d-flex flex-column gap-2">
          <h5>{t("current_plan")}</h5>
          {/* <div className="d-flex justify-content-between align-items-center gap-3"> */}
          <div className="d-flex gap-2 align-items-center">
            <img src={planImg} width={30} height={30} />
            <div className="d-flex flex-column">
              <BoldSpan>{`${planType}`}</BoldSpan>
              {!isAndroid && !isIos && (
                <NormalSpan
                  style={{ textWrap: "nowrap" }}
                >{`${currency} ${formatNumber(
                  totalAmount,
                  2
                )}/${duration}`}</NormalSpan>
              )}
            </div>
          </div>
          <div className="d-flex flex-column">
            <BoldSpan>{qtyPriceString}</BoldSpan>
            {/* {!isAndroid && !isIos && (
              <NormalSpan>{`${currency} ${(totalAmount / 12)?.toFixed(2)}/${t(
                "month_sm"
              )} (${t("billed_yearly_sm")})`}</NormalSpan>
            )} */}
          </div>
          {/* </div> */}

          {isPaymentOverdue ? (
            <div
              className="d-flex gap-1 align-items-center"
              style={{ color: "red" }}
            >
              <i
                className="fi fi-rr-triangle-warning"
                style={{ position: "relative", top: 2 }}
              />
              <NormalSpan>{t("payment_overdue")}</NormalSpan>
            </div>
          ) : (
            <NormalSpan
              style={{ color: stripeStatus === "canceled" ? "red" : "#28a745" }}
            >
              {renewsOn}
            </NormalSpan>
          )}
          {/* {!isAndroid && !isIos && (
            <>
              <LinkAnchor onClick={() => handleChangeCancel(0)}>{`${t(
                "change"
              )} / ${t("cancel_plan")}`}</LinkAnchor>
              <LinkSpan onClick={() => setShowComparePlans(true)}>
                {t("see_all_plans_and_pricing")}
              </LinkSpan>
            </>
          )} */}
        </div>
        {!isAndroid && !isIos && (
          <div>
            <PaymentMethod
              paymentData={paymentData}
              // handleChangePlan={() =>
              //   handleChangeCancel("create_customer_session", 1)
              // }
              //updateLabel={t("change_payment_method")}
            />
            <div className="d-flex flex-column gap-2 mt-2">
              {stripeStatus === "canceled" ? (
                <LinkSpan onClick={onReactivateClick}>
                  {t("reactivate_subscription")}
                </LinkSpan>
              ) : (
                <LinkAnchor
                  onClick={onChangePlanClick}
                >{`${t("change")} / ${t("cancel_plan")}`}</LinkAnchor>
              )}
              <LinkSpan onClick={() => setShowComparePlans(true)}>
                {t("see_all_plans_and_pricing")}
              </LinkSpan>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default CurrentPlanCard;
